import React from "react";
import {
  MDBNotification,
  MDBInputGroup,
  toast,
  MDBFormInline,
  MDBBadge,
  MDBAnimation,
  ToastContainer,
  MDBIcon,
  MDBDataTable,
  MDBAlert,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtnGroup,
} from "mdbreact";
import { XInput, XSelect, XBtn, XDatePicker } from "../../Components/XForm";
import Loader from "../../Components/Loader";
import { API_CONFIG, casaideas_credentials } from "../../Config/config-env.js";
import axios from "axios";
import {
  applyExternalDarkMode,
  getCasaIdeasStores,
  getStoreCodeByOfficeCode,
  parseCurrencyToNumber,
  instanteBolivia,
} from "../../Config/functions";
import LockOverlay from "../../Components/LockOverlay";

class externalForm01 extends React.Component {
  state = {
    id_producto: -1,
    mensaje: "",
    accion: "",
    isDeleted: false,
    // HU06 Preventa -- ver loadPreventaStatus/LoadTable mas abajo. preventaMap
    // marca por SKU (false = todavia no llego, true = ya confirmado);
    // preventaItems guarda el detalle crudo (incluye fecha_fin) para el
    // banner de "esperando preventa" en el render.
    preventaMap: {},
    preventaItems: [],
    // HU06 Preventa -- ver loadSyncBranchesStatus mas abajo.
    syncBranches: null,
    productQty: 1,
    productName: "",
    SKUcode: "3212567000066",
    productPrice: 0,
    existingPreviousOrder: false,
    isExecuting: false,
    modal34: false,
    cupon_interno: "",
    processing: "Procesando",
    anulacion_invoice_status: "PENDIENTE",
    tarjeta_1: "",
    anulacion_invoice_response: "",
    costo_envio: "0",
    tarjeta_2: "",
    intento_facturacion: "0",
    taskName: "",
    opcion: "",
    modal7: false,
    motivo: "",
    motivos: [
      { text: "Producto sin stock", value: "1" },
      { text: "Pedido no entregado", value: "2" },
      { text: "Cambio método de envío", value: "3" },
      { text: "Edición de pedido", value: "4" },
      { text: "Solicita cancelar pedido", value: "5" },
      { text: "Refacturación por cierre de mes", value: "6" },
      { text: "Falla en producto", value: "7" },
      { text: "No era lo que esperaba", value: "8" },
      { text: "Prueba Sistemas", value: "9" },
      { text: "Nit no corresponde", value: "10" },
      { text: "Confusión de precios", value: "11" },
      { text: "Error de precio", value: "12" },
      { text: "Error de cajero", value: "13" },
      { text: "Otro", value: "14" },
    ],
    tipos_documento: [
      {
        text: "Cédula de Identidad",
        value: "Cédula de Identidad",
        codigo: "1",
      },
      {
        text: "Cédula de Identidad de Extranjero",
        value: "Cédula de Identidad de Extranjero",
        codigo: "2",
      },
      { text: "Pasaporte", value: "Pasaporte", codigo: "3" },
      {
        text: "Otro Documento de Identidad",
        value: "Otro Documento de Identidad",
        codigo: "4",
      },
      {
        text: "Número de Identificación Tributaria",
        value: "Número de Identificación Tributaria",
        codigo: "5",
      },
    ],
    ordersPre: [
      {
        id: 0,
        product_id: 111,
        productName: "Manta",
        productPrice: "50Bs.",
        productQty: "1",
        state: "loaded",
      },
      {
        id: 1,
        product_id: 112,
        productName: "Juego de Tazas",
        productPrice: "50Bs.",
        productQty: "1",
        state: "loaded",
      },
    ],
    orders: [],
    orders2: [],
    WO_Id: "",
    isLoadedTable: false,
    loadingData: true,
    modal4: false,
    modal3: false,
    modal33: false,
    order_id: "",
    orderName: "",
    orderPrice: "Bs.50",
    orderQty: "1",
    customerName: "",
    customerAdd: "",
    customerZone: "",
    productMaxQty: 0,
    disabledAdd: true,
    monto_real: "",
    metodos: [],
    metodos_orig: [
      { text: "TARJETA ATC", value: "TARJETA ATC", checked: false },
      { text: "QR DINÁMICO LIBÉLULA", value: "QR", checked: false },

      { text: "EFECTIVO", value: "EFECTIVO", checked: false },
      { text: "TODOTIX", value: "TODOTIX", checked: false },
      { text: "QR BCP", value: "QR BCP", checked: false },
      {
        text: "LINEAS DE CRÉDITO IISA",
        value: "LINEAS DE CRÉDITO IISA",
        checked: false,
      },

      { text: "DEPOSITO", value: "DEPOSITO", checked: false },
    ],
    metodos2: [
      { text: "NINGUNO", value: "", checked: true },
      { text: "EFECTIVO", value: "EFECTIVO" },
      { text: "TARJETA ATC", value: "TARJETA ATC" },
      { text: "TARJETA LINKSER", value: "TARJETA LINKSER" },
      { text: "DEPOSITO", value: "DEPOSITO" },
      { text: "TODOTIX", value: "TODOTIX" },
      { text: "QR BCP", value: "QR BCP", checked: false },

      { text: "PAGO ALTERNATIVO", value: "PAGO ALTERNATIVO" },
      { text: "PAGO QR", value: "QR" },

      {
        text: "QR DINÁMICO LIBÉLULA",
        value: "QR DINÁMICO LIBÉLULA",
        checked: false,
      },

      {
        text: "LINEAS DE CRÉDITO IISA",
        value: "LINEAS DE CRÉDITO IISA",
        checked: false,
      },
    ],
    locked: false,
  };

  componentDidMount = () => {
    this.LoadTable();
  };

  selectHandler4 = (event) => {
    if (event[0]) {
      this.setState({ ...this.state, tipo_documento: event[0] });
    } else {
      this.setState({ ...this.state, tipo_documento: "" });
    }
  };
  selectHandler34 = (event) => {
    //console.log("dato"+event[0])
    if (event[0]) {
      this.setState({ ...this.state, motivo: event[0] });
    } else {
      this.setState({ ...this.state, motivo: "" });
    }
  };

  anulateInvoice = async (bypass) => {
    if (this.state.locked) return;
    let anulacion_invoice_response, anulacion_invoice_status, TRX;
    let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";

    let responseValidation = true;
    let numero_factura = this.state.numero_factura;
    let invoice_status = this.state.invoice_status;
    let invoice_response = this.state.invoice_response;
    if (this.state.motivo === "") {
      responseValidation = false;
      toast.warning("Debe completar el Motivo", {
        closeButton: true,
      });
    }
    if (responseValidation) {
      this.setState({ isExecuting: true });

      let InvoiceData = {
        componentcode: "anulacionXflow",
        ventaId: this.state.TRX,
        motivoId: this.state.motivo,
        codUsuario: this.state.invoice_user,
        id_pedido: this.state.order_id,
      };
      let response = {};

      await axios({
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.token,
        },
        url: API_CONFIG.xflowurl + "/engine-users/execute-api",
        //url : "http://localhost:4042/api/v1"+"/engine-users/execute-api",
        data: InvoiceData,
        method: "post",
      })
        .then((response) => response.data)
        .then((data) => {
          response = data;
        });
      console.log("response", response);

      if (!response.status) {
        anulacion_invoice_response = "Error en la anulación";
        anulacion_invoice_status = "EJECUTADO CON ERROR";

        toast.error(anulacion_invoice_response, {
          closeButton: true,
        });

        if (!response.resp1.status) {
          console.log("ERROR API Anulacion de pedido", response.resp1);
          anulacion_invoice_response = response.resp1.data;
          this.setState({
            datos_enviados:
              "....DATOS PEDIDO:..." + JSON.stringify(response.data),
          });
          try {
            anulacion_invoice_response =
              response.resp1.data.ErrorInfoExt.errorMsg +
              ".Código:" +
              response.resp1.data.ErrorInfoExt.errorCode;
          } catch (e) {
            console.log("error por default");
            anulacion_invoice_response = response.resp1.message;
          }
        }
      } else {
        console.log("OK");
        numero_factura = "";
        TRX = "0";
        invoice_response = "";
        anulacion_invoice_response = "Factura anulada correctamente";
        anulacion_invoice_status = "EJECUTADO CORRECTAMENTE";
        invoice_status = "PENDIENTE";
        toast.success("EJECUTADO CORRECTAMENTE", {
          closeButton: true,
        });
      }
      await axios({
        url: url,
        method: "put",
        data: {
          WO_flowID: this.state.WO_Id,
          WO_TaskID: this.state.WO_TaskId,
          params: [
            {
              var: "anulacion_invoice_response",
              value: anulacion_invoice_response,
            },
            {
              var: "anulacion_invoice_status",
              value: anulacion_invoice_status,
            },
            {
              var: "invoice_response",
              value: invoice_response,
            },
            { var: "invoice_status", value: invoice_status },
            { var: "anulacion_invoice_user", value: this.state.invoice_user },
            { var: "numero_factura", value: numero_factura },
          ],
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.token,
        },
      });

      this.setState({
        anulacion_invoice_response: anulacion_invoice_response,
        anulacion_invoice_status: anulacion_invoice_status,
        invoice_status: invoice_status,
        numero_factura: numero_factura,
        invoice_response: invoice_response,
      });
      this.setState({ isExecuting: false, modal34: false });
    }
  };

  generateInvoice = async (bypass) => {
    if (this.state.locked) return;
    let params = new URLSearchParams(this.props.location.search);
    let officeCode = params.get("officecode");

    let numero_factura, invoice_response, invoice_status, TRX;
    let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
    let datos_pedido = "";
    let datos_factura = "";
    let pdf_factura = "";
    console.log("this", this.state);
    if (bypass) {
      this.setState({ isExecuting: true });

      numero_factura = "0";
      invoice_response = "BYPASS APLICADO";
      invoice_status = "BYPASS";
      TRX = "0";
      console.log("bypass");

      this.setState({
        invoice_response: invoice_response,
        numero_factura: numero_factura,
        invoice_status: invoice_status,
        TRX: TRX,
      });

      await axios({
        url: url,
        method: "put",
        data: {
          WO_flowID: this.state.WO_Id,
          WO_TaskID: this.state.WO_TaskId,
          params: [
            { var: "numero_factura", value: numero_factura },
            { var: "invoice_response", value: invoice_response },
            { var: "invoice_status", value: invoice_status },
            { var: "TRX", value: TRX },
          ],
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.token,
        },
      });

      this.setState({ isExecuting: false, modal33: false });
      toast.success("BYPASS APLICADO", {
        closeButton: true,
      });
    } else {
      let responseValidation = true;

      if (
        this.state.metodo_pago === "TARJETA ATC" ||
        this.state.metodo_pago === "TARJETA LINKSER" ||
        this.state.metodo_pago_2 === "TARJETA ATC" ||
        this.state.metodo_pago_2 === "TARJETA LINKSER"
      ) {
        if (this.state.tarjeta_1.length != 4) {
          responseValidation = false;
          toast.warning("Debe completar los primeros 4 dígitos de la tarjeta", {
            closeButton: true,
          });
        }
        if (this.state.tarjeta_2.length != 4) {
          responseValidation = false;
          toast.warning("Debe completar los últimos 4 dígitos de la tarjeta", {
            closeButton: true,
          });
        }
      }

      if (this.state.razon_social === "") {
        responseValidation = false;
        toast.warning("Debe completar la razón social", { closeButton: true });
      }

      if (this.state.nit === "") {
        responseValidation = false;
        toast.warning("Debe completar la Nit/Carnet de Identidad", {
          closeButton: true,
        });
      }

      if (this.state.tipo_documento === "") {
        responseValidation = false;
        toast.warning("Debe completar el Tipo de Documento", {
          closeButton: true,
        });
      }
      let monto_total = 0;
      if (responseValidation) {
        this.setState({ isExecuting: true });
        let listaProductos = [];
        let id_pedido = this.state.order_id;

        this.state.orders.map((sku, index) => {
          var montoDescuento = 0;

          if ((parseCurrencyToNumber(sku.new_price) || 0) > 0) {
            montoDescuento =
              (parseCurrencyToNumber(sku.originalPrice) || 0) -
              (parseCurrencyToNumber(sku.new_price) || 0);
          }

          var textoRefDescuento = "";

          if (sku.disc_type === "%") {
            textoRefDescuento = "Descuento";
          } else if (sku.disc_type === "COMBO") {
            textoRefDescuento = "Combo";
          } else {
            if (sku.disc_type !== "") {
              textoRefDescuento = sku.type;
            }
          }

          monto_total +=
            parseCurrencyToNumber(sku.originalPrice) * sku.productQty;

          listaProductos.push({
            linea: 1,
            codProducto: sku.productSKU,
            descripcion: sku.productName,
            precioLista: parseCurrencyToNumber(sku.originalPrice),
            precioFinal:
              parseCurrencyToNumber(sku.new_price) === 0
                ? parseCurrencyToNumber(sku.originalPrice)
                : parseCurrencyToNumber(sku.new_price),

            cantidad: sku.productQty,
            codDescuento: "",
            montoDescuento: montoDescuento,
            textoRefDescuento: textoRefDescuento,
            codBodega: this.state.storeCodeI,
            nroPedidoRef: id_pedido,
          });
        });
        monto_total = parseFloat(monto_total.toFixed(1));

        const partes = this.state.razon_social.split(" ");
        const nombres = partes[0];
        const apellidoPat = partes.length > 1 ? partes[1] : "";
        const apellidoMat = partes.length > 2 ? partes.slice(2).join(" ") : "";

        if (this.state.monto_real !== "") {
          monto_total = parseFloat(
            this.state.monto_real.replace(",", ".")
          ).toFixed(1);
        }

        const monto_2 = Number(
          parseFloat(this.state.monto_2.replace(",", ".")).toFixed(2)
        );

        let costo_envio = 0;
        if (this.state.costo_envio !== "") {
          costo_envio = Number(
            parseFloat(this.state.costo_envio.replace(",", ".")).toFixed(2)
          );
        }
        console.log("listaProductos", listaProductos);
        console.log("monto_total", monto_total);
        console.log("this.state.monto_real", this.state.monto_real);

        console.log("costo_envio", costo_envio);
        let InvoiceData = {
          montoPedido: monto_total,
          officeCode: officeCode,
          monto_2: monto_2,
          metodo_pago_2: this.state.metodo_pago_2,
          componentcode: "facturaXflow",
          id_pedido: id_pedido,
          nit: this.state.nit,
          descuento: this.state.descuento,
          razonSocial: this.state.razon_social,
          nombres: nombres,
          apellidoPat: apellidoPat,
          apellidoMat: apellidoMat,
          email: this.state.email,
          telefono: this.state.telefono.replace("+591 ", ""),
          direccion: this.state.direccion_1,
          referencia: this.state.direccion_2,
          ciudad: this.state.ciudad,
          tarjeta_1: this.state.tarjeta_1,
          tarjeta_2: this.state.tarjeta_2,
          listaProductos: listaProductos,
          storeCodeI: this.state.storeCodeI,
          metodo_pago: this.state.metodo_pago,
          fecha_pago: this.state.from_date,
          codUsuario: this.state.invoice_user,
          cupon_interno: this.state.codigo_cupon,
          costo_envio: costo_envio,
          intento_facturacion: parseInt(this.state.intento_facturacion),
        };
        let response = {};

        await axios({
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.state.token,
          },
          url: API_CONFIG.xflowurl + "/engine-users/execute-api",
          data: InvoiceData,
          method: "post",
        })
          .then((response) => response.data)
          .then((data) => {
            response = data;
          });
        console.log("response", response);

        if (!response.status) {
          invoice_response = "Error en la facturación";
          invoice_status = "EJECUTADO CON ERROR";
          numero_factura = "-1";
          TRX = "0";
          toast.error(invoice_response, {
            closeButton: true,
          });

          datos_pedido = JSON.stringify(response.data);
          datos_factura = JSON.stringify(response.data2);

          if (!response.resp1.status) {
            console.log("ERROR API Creacion de pedido", response.resp1);
            invoice_response = response.resp1.data;
            this.setState({
              datos_enviados:
                "....DATOS PEDIDO:..." +
                JSON.stringify(response.data) +
                "....DATOS FACTURA:..." +
                JSON.stringify(response.data2),
            });
            try {
              invoice_response =
                response.resp1.data.ErrorInfoExt.errorMsg +
                ".Código:" +
                response.resp1.data.ErrorInfoExt.errorCode;
            } catch (e) {
              console.log("error por default");
              invoice_response = response.resp1.message;
            }
          } else {
            if (!response.resp2.status) {
              console.log(
                "Error API Facturacion",
                response.resp2.data.ErrorInfoExt
              );
              this.setState({
                datos_enviados:
                  "....DATOS PEDIDO:..." +
                  JSON.stringify(response.data) +
                  "....DATOS FACTURA:..." +
                  JSON.stringify(response.data2),
              });
              try {
                invoice_response =
                  response.resp2.data.ErrorInfoExt.errorMsg +
                  ".Código:" +
                  response.resp2.data.ErrorInfoExt.errorCode;
              } catch (e) {
                console.log("error por default");
                invoice_response = response.resp2.message;
              }
            }
          }
        } else {
          console.log("OK");
          invoice_response = "Factura generada correctamente";
          invoice_status = "EJECUTADO CORRECTAMENTE";

          numero_factura = response.resp2.RespCrearVentaDesdePedidoDatos.numDoc;
          TRX = response.resp2.RespCrearVentaDesdePedidoDatos.nroTrx;
          pdf_factura = response.resp2.RespCrearVentaDesdePedidoDatos.pdfbase64;
          datos_pedido = JSON.stringify(response.data);
          datos_factura = JSON.stringify(response.data2);

          toast.success("EJECUTADO CORRECTAMENTE", {
            closeButton: true,
          });
        }
        await axios({
          url: url,
          method: "put",
          data: {
            WO_flowID: this.state.WO_Id,
            WO_TaskID: this.state.WO_TaskId,
            params: [
              { var: "numero_factura", value: numero_factura },
              { var: "invoice_response", value: invoice_response },
              { var: "invoice_status", value: invoice_status },
              { var: "TRX", value: TRX },
              { var: "pdf_factura", value: pdf_factura },
              { var: "datos_pedido", value: datos_pedido },
              { var: "datos_factura", value: datos_factura },
              {
                var: "intento_facturacion",
                value: response.intento_facturacion,
              },
              {
                var: "anulacion_invoice_status",
                value: "",
              },
              {
                var: "anulacion_invoice_response",
                value: "",
              },
            ],
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.state.token,
          },
        });

        this.setState({
          numero_factura: numero_factura,
          invoice_response: invoice_response,
          pdf_factura: pdf_factura,
          invoice_status: invoice_status,
          TRX: TRX,
          intento_facturacion: response.intento_facturacion,
          anulacion_invoice_status: "",
        });
        this.setState({ isExecuting: false, modal33: false });
      }
    }
  };
  generateInvoiceOld = async (bypass) => {
    if (this.state.locked) return;
    let numero_factura, invoice_response, invoice_status, TRX;
    let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";

    if (bypass) {
      let responseValidation = true;

      if (this.state.numero_factura === "") {
        toast.warning("Debe completar la Factura Manual", {
          closeButton: true,
        });
        responseValidation = false;
        this.setState({
          modal7: true,
        });
      }
      if (responseValidation) {
        this.setState({ isExecuting: true });

        numero_factura = this.state.numero_factura;
        invoice_response = "BYPASS APLICADO";
        invoice_status = "BYPASS";
        TRX = "0";
        console.log("bypass");

        this.setState({
          invoice_response: invoice_response,
          numero_factura: numero_factura,
          invoice_status: invoice_status,
          TRX: TRX,
        });

        await axios({
          url: url,
          method: "put",
          data: {
            WO_flowID: this.state.WO_Id,
            WO_TaskID: this.state.WO_TaskId,
            params: [
              { var: "numero_factura", value: numero_factura },
              { var: "invoice_response", value: invoice_response },
              { var: "invoice_status", value: invoice_status },
              { var: "TRX", value: TRX },
              { var: "invoice_user", value: this.state.invoice_user },
              // Momento real de la facturacion, no this.state.from_date: ese estado es
              // el del picker "Fecha de pago", que el cajero puede cambiar, y arrastraba
              // la fecha de factura con el. Con el offset -04:00 declarado, ningun tramo
              // de la cadena lo reinterpreta segun su propia zona.
              { var: "invoice_date", value: instanteBolivia() },
            ],
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.state.token,
          },
        });

        this.setState({ isExecuting: false, modal33: false });
        toast.success("BYPASS APLICADO", {
          closeButton: true,
        });
      }
    } else {
      let responseValidation = true;

      if (this.state.razon_social === "") {
        responseValidation = false;
        toast.warning("Debe completar la razon social", { closeButton: true });
      }

      if (this.state.nit === "") {
        responseValidation = false;
        toast.warning("Debe completar la Nit/Carnet de Identidad", {
          closeButton: true,
        });
      }

      if (this.state.tipo_documento === "") {
        responseValidation = false;
        toast.warning("Debe completar el Tipo de Documento", {
          closeButton: true,
        });
      }
      if (responseValidation) {
        this.setState({ isExecuting: true });
        setTimeout(
          async function () {
            if (this.state.nit === "606060") {
              invoice_response = "Error en la facturación(TEST)";
              invoice_status = "EJECUTADO CON ERROR";
              numero_factura = "-1";
              TRX = "0";
              toast.error(invoice_response, {
                closeButton: true,
              });
            } else {
              console.log("OK");
              invoice_response = "Factura generada correctamente";
              invoice_status = "EJECUTADO CORRECTAMENTE";
              numero_factura =
                Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000;
              TRX = Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000;
              toast.success("EJECUTADO CORRECTAMENTE", {
                closeButton: true,
              });
            }
            await axios({
              url: url,
              method: "put",
              data: {
                WO_flowID: this.state.WO_Id,
                WO_TaskID: this.state.WO_TaskId,
                params: [
                  { var: "numero_factura", value: numero_factura },
                  { var: "invoice_response", value: invoice_response },
                  { var: "invoice_status", value: invoice_status },
                  { var: "TRX", value: TRX },
                  {
                    var: "comentario_factura",
                    value: this.state.comentario_factura,
                  },
                ],
              },
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.state.token,
              },
            });

            this.setState({
              numero_factura: numero_factura,
              invoice_response: invoice_response,
              invoice_status: invoice_status,
              TRX: TRX,
            });
            this.setState({ isExecuting: false, modal33: false });
          }.bind(this),
          1500
        );
      }
    }
  };

  changeHandler = (event) => {
    this.setState({ ...this.state, [event.target.name]: [event.target.value] });
  };

  LoadTable = async () => {
    let params = new URLSearchParams(this.props.location.search);
    applyExternalDarkMode(this.props.location.search);
    let token = params.get("token");
    let WO_Id = params.get("wfpflowid");
    let WOTaskId = params.get("wfptaskid");
    let officecode = params.get("officecode");
    let locked = params.get("locked") === "true";
    const storesCatalog = await getCasaIdeasStores();
    let storeCodeI = getStoreCodeByOfficeCode(officecode, storesCatalog);
    var userId = -1;
    var order_id = 0;
    var customer_id = 0;
    var nombre_cliente = "";
    var pedido_modificado = "";
    var costo_envio = "0";
    var descuento = "";
    var direccion_1 = "";
    var zona = "";
    var pedido_parcial = "";
    var mixed_skus = [];
    var flowcode;
    this.setState({
      isLoadedTable: false,
      WO_Id: WO_Id,
      loadingData: true,
      storeCodeI: storeCodeI,
    });

    console.log(WOTaskId);
    var cupon = "";
    var codigo_cupon = "";
    await axios({
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      url: API_CONFIG.xflowurl + "/engine-users/get-task-details",
      //url : "http://localhost:4042/api/v1"+"/engine-users/get-task-details",
      data: {
        wfptaskid: WOTaskId,
      },
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        if (data.status) {
          flowcode = data.task.FLOWCODE;
          let taskName = data.task.TASK;
          this.setState({ taskName: taskName });

          for (let v in data.flowvars) {
            let flowVar = data.flowvars[v];
            if (flowVar.VARNAME === "order_id") {
              order_id = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "customer_id") {
              customer_id = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "nombre_cliente") {
              nombre_cliente = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "pedido_modificado") {
              pedido_modificado = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "costo_envio") {
              costo_envio = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "descuento") {
              descuento = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "direccion_1") {
              direccion_1 = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "zona") {
              zona = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "pedido_parcial") {
              pedido_parcial = flowVar.VARVALUE;
            }

            if (flowVar.VARNAME === "tipo_documento") {
              const tipos_documento = this.state.tipos_documento.map(
                (documento) => {
                  if (documento.text === flowVar.VARVALUE) {
                    return { ...documento, checked: true };
                  }
                  return documento;
                }
              );
              this.setState({ tipos_documento: tipos_documento });
              this.setState({ tipo_documento: flowVar.VARVALUE });
            }

            if (flowVar.VARNAME === "mixed_skus") {
              try {
                mixed_skus = JSON.parse(flowVar.VARVALUE);
              } catch (ex) {
                console.log("EX", ex);
              }
            }
            if (flowVar.VARNAME !== "invoice_user") {
              this.setState({ [flowVar.VARNAME]: flowVar.VARVALUE });
            }
          }
        }
      });

    var isSupervisor, isAdmin;
    await axios({
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      url: API_CONFIG.xflowurl + "/engine-users/decrypt-token",
      //url : "http://localhost:4042/api/v1"+"/engine-users/decrypt-token",
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        //console.log("data", data);
        if (data.status) {
          userId = data.token.USERID;
          isSupervisor = data.token.USERGROUP === "SINGLEUSER" ? -1 : 1;
          isAdmin = data.token.USERGROUP === "ADMINECOM" ? 1 : -1;
          this.setState({
            ...this.state,
            username: data.token.USERNAME,
            invoice_user: data.token.USERNAME,
            organization: data.token.ORGANIZATIONCODE,
            userId: userId,
          });
        }
      });

    //let idTask = this.props.match.params.idTask;
    let url = API_CONFIG.getorderByIdpath;

    if (
      process.env.REACT_APP_BACKEND_CONFIG === "https://backv2.casaideas.com.bo"
    ) {
      url = API_CONFIG.casaideas + "/externalapi/execute/getorderById";
    }

    var fcosto_envio = costo_envio ? parseFloat(costo_envio, 2).toFixed(2) : 0;
    console.log("fcosto_envio", fcosto_envio);
    this.setState({
      ...this.state,
      costo_envio: fcosto_envio,
      token: token,
      WO_Id: WO_Id,
      WO_TaskId: WOTaskId,
      officecode: officecode,
      storeCodeI: storeCodeI,
    });

    // console.log("flowcode", flowcode);
    await axios({
      url: url,
      method: "post",
      data: {
        username: casaideas_credentials.user,
        password: casaideas_credentials.password,
        order_id: order_id,
        customer_id: customer_id,
        adminpath: "matrix",
      },
    })
      .then((response) => response.data)
      .then((data) => {
        var arr = [];
        var arr2 = [];
        var i = 0;
        if (data.success) {
          cupon = data.response[0].order_info.codigo_cupon ?? "";
          codigo_cupon = data.response[0].order_info.codigo_cupon_interno ?? "";
          data = {
            resp: "OK",
            rows: data.response[0].products,
          };
        }
        if (data.resp === "OK" && data.rows.length > 0) {
          if (pedido_parcial === "SI") {
            //console.log(mixed_skus)
            console.log("parcial");
            for (let k in mixed_skus) {
              let sku = mixed_skus[k];
              //console.log("sku original ", sku.sku)

              let isValid = false;
              for (let m in data.rows) {
                let key = data.rows[m];
                if (sku.sku === key.sku) {
                  if (flowcode === "flowBolCI07") {
                    //console.log("tienda online", sku.sku , key.sku , officecode , sku.store)
                    //pickup del restante de la otra tienda
                    if (officecode !== sku.store) {
                      arr.push({
                        id: key,
                        product_id: key.product_id,
                        productName: key.name,
                        new_price: key.new_price,
                        disc_type: key.disc_type,
                        productModel: key.model,
                        productPrice: key.price,
                        originalPrice: key.productPrice,
                        productQty: key.quantity,
                        productImage: key.image,
                        productSKU: key.sku,
                        state: "loaded",
                      });
                    } else {
                      arr2.push({
                        id: key,
                        product_id: key.product_id,
                        productName: key.name,
                        productModel: key.model,
                        productPrice: key.price,
                        originalPrice: key.productPrice,
                        productQty: key.quantity,
                        productImage: key.image,
                        productSKU: key.sku,
                        state: "loaded",
                      });
                    }
                  } else {
                    //console.log("tienda no online")
                    //es la tienda original
                    if (officecode === sku.store) {
                      arr.push({
                        id: key,
                        product_id: key.product_id,
                        productName: key.name,
                        new_price: key.new_price,
                        disc_type: key.disc_type,
                        productModel: key.model,
                        originalPrice: key.productPrice,
                        productPrice: key.price,
                        productQty: key.quantity,
                        productImage: key.image,
                        productSKU: key.sku,
                        state: "loaded",
                      });
                    } else {
                      arr2.push({
                        id: key,
                        product_id: key.product_id,
                        productName: key.name,
                        productModel: key.model,
                        originalPrice: key.productPrice,
                        productPrice: key.price,
                        productQty: key.quantity,
                        productImage: key.image,
                        productSKU: key.sku,
                        state: "loaded",
                      });
                    }
                  }
                }
              }
            }
          } else {
            console.log("no parcial");
            for (let key in data.rows) {
              arr.push({
                id: key,
                product_id: data.rows[key].product_id,
                productName: data.rows[key].name,
                productModel: data.rows[key].model,
                originalPrice: data.rows[key].productPrice,
                productPrice: data.rows[key].price,
                productQty: data.rows[key].quantity,
                new_price: data.rows[key].new_price,
                disc_type: data.rows[key].disc_type,
                productImage: data.rows[key].image,
                productSKU: data.rows[key].sku,
                state: "loaded",
              });
            }
          }
        }
        console.log("arr", arr);
        console.log("arr2", arr2);
        this.setState({
          ...this.state,
          orders: arr,
          orders2: arr2,
          codigo_cupon: codigo_cupon,
          cupon: cupon,
          flowcode: flowcode,
          isLoadedTable: true,
          customerName: nombre_cliente,
          customerAdd: direccion_1,
          customerZone: zona,
          customer_id: customer_id,
          loadingData: false,
          existingPreviousOrder: false /*revisar*/,
          isDeleted: false /*revisar*/,
          order_id: order_id /*revisar*/,
          locked: locked,
        });

        this.loadPreventaStatus(order_id);
        this.loadSyncBranchesStatus(order_id);
      });
  };

  // HU06 Preventa -- estado del AND-join (engine.syncBranches) para este
  // order_id, via el endpoint de solo lectura nuevo (get-sync-branches-
  // status, ver engine.model.js/getSyncBranchesStatus en xflow_backv2).
  // Da el numero real de ramas que ya llegaron vs las esperadas -- antes
  // esta pantalla solo decia "en espera" sin ese dato.
  loadSyncBranchesStatus = async (order_id) => {
    if (!order_id) return;
    await axios({
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.token,
      },
      url: API_CONFIG.xflowurl + "/engine-users/get-sync-branches-status",
      data: { syncKey: "order_id", syncValue: order_id },
    })
      .then((r) => r.data)
      .then((data) => {
        if (data.status) {
          this.setState({ syncBranches: data });
        }
      })
      .catch(() => {
        // No bloquea la pantalla si falla -- es solo informativo.
      });
  };

  // HU06 Preventa -- este form (FRMESP, TASKID 67 "Pedidos en espera") es la
  // tarea a la que cae un pedido combinado (traspaso + preventa) cuando el
  // AND-join de TASKID 19 (flowBolCI08) cuenta menos ramas de las esperadas
  // -- es decir, mientras la rama de preventa (flowBolCI09) todavia no
  // resolvio. Antes esta pantalla no distinguia esto de un pedido en espera
  // por cualquier otro motivo -- el operador no tenia forma de saber QUE
  // faltaba. Reusa checkDisponibilidad (mismo endpoint que ya gatea Picking
  // Global/Individual/Preventa) para mostrar el pill por SKU y el banner de
  // abajo con la fecha_fin de preventa como referencia (puede venir null si
  // el CMS no cargo fecha de cierre para ese SKU).
  loadPreventaStatus = async (order_id) => {
    if (!order_id) return;
    await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/preventa/checkDisponibilidad",
      data: { order_id, apikey: API_CONFIG.casaideasIntToken },
    })
      .then((r) => r.data)
      .then((data) => {
        const preventaMap = {};
        (data.items || []).forEach((item) => {
          preventaMap[item.sku] = item.disponible;
        });
        this.setState({ preventaMap, preventaItems: data.items || [] });
      })
      .catch(() => {
        // No bloquea la pantalla si falla -- es solo informativo.
      });
  };

  toggleModal = (nr) => () => {
    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber],
    });
  };

  render() {
    return (
      <>
        <MDBContainer
          className="xext-page xext-form03"
          style={{ maxWidth: "1024px", width: "100%" }}
        >
          <LockOverlay visible={this.state.locked && !this.state.loadingData} />
          {this.state.loadingData ? (
            <Loader idLoading={this.state.loadingData} />
          ) : (
            <>
              <Loader idLoading={this.state.isExecuting} />

              <h3 className="xext-page-title xext-page-title--compact">
                {" "}
                {"Pedido: " + this.state.order_id}
              </h3>

              {(() => {
                const pendientes = (this.state.preventaItems || []).filter(
                  (i) => i.disponible === false
                );
                if (pendientes.length === 0) return null;
                const todos = [
                  ...this.state.orders,
                  ...this.state.orders2,
                  ...(this.state.ordersPre || []),
                ];
                const branchLabels = {
                  directo: "Stock directo",
                  stock: "Stock",
                  traspaso: "Traspaso a otra tienda",
                  preventa: "Preventa",
                };
                const sb = this.state.syncBranches;
                return (
                  <div className="xext-preventa-wait-banner">
                    <MDBIcon icon="hourglass-half" />{" "}
                    <strong>Este pedido esta en espera</strong> -- todavia
                    falta que llegue la preventa de{" "}
                    {pendientes.length === 1 ? "este producto" : "estos productos"}{" "}
                    antes de poder continuar:
                    {sb && sb.expectedBranches != null && (
                      <p className="xext-preventa-wait-branches">
                        <strong>
                          {sb.arrivedCount} de {sb.expectedBranches} ramas
                          completadas:
                        </strong>{" "}
                        {sb.arrivedBranches && sb.arrivedBranches.length > 0
                          ? sb.arrivedBranches
                              .map(
                                (b) =>
                                  branchLabels[b.branchName] ||
                                  b.branchName ||
                                  "(sin identificar)"
                              )
                              .join(", ")
                          : "ninguna todavia"}
                        {" -- falta"}
                        {sb.expectedBranches - sb.arrivedCount === 1
                          ? " 1 rama mas"
                          : ` ${sb.expectedBranches - sb.arrivedCount} ramas mas`}
                        {pendientes.length > 0 && " (al menos la de preventa)"}
                      </p>
                    )}
                    <ul className="xext-preventa-wait-list">
                      {pendientes.map((item) => {
                        const match = todos.find(
                          (o) => o.productSKU === item.sku
                        );
                        return (
                          <li key={item.sku}>
                            <strong>{match ? match.productName : item.sku}</strong>{" "}
                            (SKU {item.sku})
                            {item.fecha_fin && (
                              <>
                                {" "}
                                -- fecha de fin de preventa (referencial):{" "}
                                {new Date(item.fecha_fin).toLocaleDateString(
                                  "es-BO"
                                )}
                              </>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })()}

              {this.state.orders.map((event) => (
                <p key={"event1" + event.id} style={{ width: "98%" }}>
                  <Event
                    id={event.id}
                    product_id={".000" + event.product_id}
                    productName={event.productName}
                    productQty={event.productQty}
                    productPrice={event.productPrice}
                    productModel={event.productModel}
                    productImage={event.productImage}
                    productSKU={event.productSKU}
                    state={event.state}
                    onDelete={null}
                    onEdit={null}
                    onPick={this.handlePick}
                    preventaStatus={this.state.preventaMap[event.productSKU]}
                  />
                </p>
              ))}

              {this.state.flowcode === "flowBolCI03" && (
                <MDBRow className="ml-1" style={{ width: "99%" }}>
                  <MDBCol size="12" sm="12" md="6" lg="6">
                    <div
                      style={{
                        border: "1px solid #00c851",
                        padding: 5,
                        borderRadius: 5,
                      }}
                    >
                      <h5>Facturación en linea</h5>

                      {this.state.invoice_status ===
                        "EJECUTADO CORRECTAMENTE" ||
                      this.state.invoice_status === "BYPASS" ? (
                        <MDBAlert
                          color="info"
                          className="d-flex align-items-center"
                        >
                          <MDBIcon icon="info-circle" className="mr-2" />
                          Factura generada
                        </MDBAlert>
                      ) : (
                        /*
                        <XBtn
                          size="sm"
                          color="success"
                          onClick={() => {
                            console.log("thiss", this.state);
                            if (this.state.metodo_pago === "") {
                              toast.error(
                                "Por favor escoja un Métdoo de pago",
                                {
                                  closeButton: true,
                                }
                              );
                            } else {
                              this.setState({
                                modal33: true,
                              });
                            }
                          }}
                        >
                          <MDBIcon icon="file-invoice" /> Generar Factura
                        </XBtn>*/ ""
                      )}

                      <div style={{ borderTop: "1px solid #00c851" }}>
                        <MDBRow>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            Número Factura:
                          </MDBCol>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            {this.state.numero_factura == ""
                              ? "0"
                              : this.state.numero_factura}
                            <input
                              type="hidden"
                              value={this.state.numero_factura}
                            />
                          </MDBCol>
                        </MDBRow>

                        <MDBRow>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            Respuesta:
                          </MDBCol>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            {this.state.invoice_status}
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            Descripción:
                          </MDBCol>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            {this.state.invoice_status != "PENDIENTE" ? (
                              <>
                                <MDBAlert
                                  color={
                                    this.state.invoice_status ===
                                    "EJECUTADO CON ERROR"
                                      ? "danger"
                                      : "success"
                                  }
                                  className="d-flex align-items-center"
                                >
                                  <MDBIcon
                                    icon={
                                      this.state.invoice_status ===
                                      "EJECUTADO CON ERROR"
                                        ? "times-circle"
                                        : "check-circle"
                                    }
                                    className="mr-2"
                                  />
                                  {this.state.invoice_response}
                                </MDBAlert>
                              </>
                            ) : (
                              <>{this.state.invoice_response}</>
                            )}
                          </MDBCol>
                        </MDBRow>
                      </div>
                    </div>
                  </MDBCol>

                  <MDBCol
                    size="12"
                    sm="6"
                    md="6"
                    lg="6"
                    xl="6"
                    className="text-right"
                  >
                    <XInput
                      style={{ margin: "0" }}
                      id={"TRX"}
                      key={"TRX"}
                      name={"TRX"}
                      disabled={this.state.invoice_status !== "BYPASS"}
                      readonly={this.state.invoice_status !== "BYPASS"}
                      value={this.state.TRX}
                      onChange={this.changeHandler}
                      size="sm"
                      label="TRX"
                    />

                    {this.state.invoice_status === "BYPASS" && (
                      <XInput
                        className="mt-3"
                        id={"numero_factura"}
                        key={"numero_factura"}
                        name={"numero_factura"}
                        disabled={this.state.invoice_status !== "BYPASS"}
                        readonly={this.state.invoice_status !== "BYPASS"}
                        value={this.state.numero_factura}
                        onChange={this.changeHandler}
                        size="sm"
                        label="Número Factura"
                      />
                    )}

                    <XInput
                      className="mt-3"
                      id={"comentario_factura"}
                      key={"comentario_factura"}
                      name={"comentario_factura"}
                      value={this.state.comentario_factura}
                      onChange={this.changeHandler}
                      size="sm"
                      label="Observaciones"
                    />
                  </MDBCol>
                </MDBRow>
              )}

              {(this.state.taskName == "Seguimiento de Pedidos" ||
                this.state.taskName == "Pedido observado post venta") && (
                /*this.state.invoice_status === "EJECUTADO CORRECTAMENTE" &&*/ <MDBRow
                  className="ml-1 mt-3"
                  style={{ width: "99%" }}
                >
                  <MDBCol size="12" sm="12" md="6" lg="6">
                    <div
                      style={{
                        border: "1px solid #00c851",
                        padding: 5,
                        borderRadius: 5,
                      }}
                    >
                      <h5>Información de la factura para anulación</h5>

                      {this.state.anulacion_invoice_status ===
                        "EJECUTADO CORRECTAMENTE" &&
                      this.state.invoice_status !== "BYPASS" ? (
                        <MDBAlert
                          color="info"
                          className="d-flex align-items-center"
                        >
                          <MDBIcon icon="info-circle" className="mr-2" />
                          Factura anulada
                        </MDBAlert>
                      ) : (
                        <XBtn
                          size="sm"
                          color="success"
                          onClick={() => {
                            this.setState({
                              modal34: true,
                            });
                          }}
                        >
                          <MDBIcon icon="file-invoice" /> Anular Factura
                        </XBtn>
                      )}
                      <div style={{ borderTop: "1px solid #00c851" }}>
                        <MDBRow>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            Número Factura:
                          </MDBCol>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            {this.state.numero_factura == ""
                              ? "0"
                              : this.state.numero_factura}
                            <input
                              type="hidden"
                              value={this.state.numero_factura}
                            />
                          </MDBCol>
                        </MDBRow>

                        <MDBRow>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            TRX:
                          </MDBCol>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            {this.state.TRX == "" ? "0" : this.state.TRX}
                            <input type="hidden" value={this.state.TRX} />
                          </MDBCol>
                        </MDBRow>

                        <MDBRow>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            Respuesta Anulación:
                          </MDBCol>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            {this.state.anulacion_invoice_status}
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            Descripción:
                          </MDBCol>
                          <MDBCol
                            sm="12"
                            md="6"
                            lg="6"
                            className=" text-left left"
                          >
                            {this.state.anulacion_invoice_status &&
                            this.state.anulacion_invoice_status.trim() !== "" &&
                            this.state.anulacion_invoice_status !==
                              "PENDIENTE" ? (
                              <>
                                <MDBAlert
                                  color={
                                    this.state.anulacion_invoice_status ===
                                    "EJECUTADO CON ERROR"
                                      ? "danger"
                                      : "success"
                                  }
                                  className="d-flex align-items-center"
                                >
                                  <MDBIcon
                                    icon={
                                      this.state.anulacion_invoice_status ===
                                      "EJECUTADO CON ERROR"
                                        ? "times-circle"
                                        : "check-circle"
                                    }
                                    className="mr-2"
                                  />

                                  {this.state.anulacion_invoice_response}
                                  <MDBIcon
                                    icon="unlink"
                                    className="ml-2 text-warning"
                                    title="Operación anulada"
                                  />
                                </MDBAlert>
                              </>
                            ) : (
                              <>{this.state.anulacion_invoice_response}</>
                            )}
                          </MDBCol>
                        </MDBRow>
                      </div>
                    </div>
                  </MDBCol>

                  <MDBCol
                    size="12"
                    sm="6"
                    md="6"
                    lg="6"
                    xl="6"
                    className="text-right"
                  ></MDBCol>
                </MDBRow>
              )}

              {this.state.orders2.length > 0 && (
                <>
                  <MDBRow className="text-left">
                    <MDBCol md="12">
                      <h4
                        style={{
                          zIndex: "1000",
                          fontWeight: "600",
                          color: "#000",
                        }}
                      >
                        {" "}
                        {"Productos a cargo de la otra tienda"}{" "}
                      </h4>
                    </MDBCol>
                  </MDBRow>
                  {this.state.orders2.map((event) => (
                    <p key={"event1" + event.id} style={{ width: "98%" }}>
                      <Event
                        id={event.id}
                        product_id={".000" + event.product_id}
                        productName={event.productName}
                        productQty={event.productQty}
                        productPrice={event.productPrice}
                        productModel={event.productModel}
                        productImage={event.productImage}
                        productSKU={event.productSKU}
                        background={"#FFD0D0"}
                        state={event.state}
                        onDelete={null}
                        onEdit={null}
                        onPick={this.handlePick}
                        preventaStatus={this.state.preventaMap[event.productSKU]}
                      />
                    </p>
                  ))}
                </>
              )}
              {this.state.datos_enviados}
              {this.state.pdf_factura && (
                <MDBRow
                  className="text-center flex-center"
                  style={{ marginTop: 15, marginBottom: 15 }}
                >
                  <MDBCol md="12" lg="6" xl="4">
                    <h3>Datos de la Factura generada</h3>
                    {/*this.state.datos_enviados*/}
                    <div>
                      <embed
                        src={`data:application/pdf;base64,${this.state.pdf_factura}`}
                        type="application/pdf"
                        width="100%"
                        height="600px"
                      />
                    </div>
                  </MDBCol>
                </MDBRow>
              )}

              <MDBModal
                cascading
                centered
                isOpen={this.state.modal33}
                toggle={this.toggleModal(33)}
                size="lg"
              >
                <MDBModalBody>
                  <span className="h2-responsive mb-4">
                    {" "}
                    <MDBIcon icon="cart-arrow-down" className="mr-1" />{" "}
                    {"Facturación en linea"}
                  </span>

                  <>
                    {(this.state.metodo_pago === "TARJETA ATC" ||
                      this.state.metodo_pago === "TARJETA LINKSER" ||
                      this.state.metodo_pago_2 === "TARJETA ATC" ||
                      this.state.metodo_pago_2 === "TARJETA LINKSER") && (
                      <div className="row">
                        <div className=" col-sm-12 col-md-9">
                          <h5>Complete los datos de la tarjeta</h5>
                        </div>
                        <div className=" col-sm-12 col-md-9">
                          <div className="row">
                            <div className="col-3 col-sm-3 col-md-2">
                              <XInput
                                id="tarjeta_1"
                                key="tarjeta_1"
                                name="tarjeta_1"
                                placeHolder="0000"
                                maxLength="4"
                                value={this.state.tarjeta_1}
                                onChange={this.changeHandler}
                                size="xs"
                              />
                            </div>
                            <div
                              style={{
                                fontSize: 16,
                                fontWeight: "600",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className="col-3 col-sm-3 col-md-2"
                            >
                              {" "}
                              XXXX
                            </div>
                            <div
                              style={{
                                fontSize: 16,
                                fontWeight: "600",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className="col-3 col-sm-3 col-md-2"
                            >
                              {" "}
                              XXXX{" "}
                            </div>
                            <div className="col-3 col-sm-3 col-md-2">
                              <XInput
                                id="tarjeta_2"
                                key="tarjeta_2"
                                name="tarjeta_2"
                                placeHolder="0000"
                                maxLength="4"
                                value={this.state.tarjeta_2}
                                onChange={this.changeHandler}
                                size="xs"
                              />
                            </div>
                            <div className="col-12 col-sm-12 col-md-4"></div>
                          </div>
                        </div>
                      </div>
                    )}
                    <MDBRow className="text-right mt-3">
                      <MDBCol md="9">
                        <XInput
                          id="razon_social"
                          key="razon_social"
                          name="razon_social"
                          value={this.state.razon_social}
                          onChange={this.changeHandler}
                          size="sm"
                          label="Razón social"
                        />
                      </MDBCol>
                    </MDBRow>

                    <MDBRow className="text-right mt-3">
                      <MDBCol md="9">
                        <XInput
                          id="nit"
                          key="nit"
                          name="nit"
                          value={this.state.nit}
                          onChange={this.changeHandler}
                          size="sm"
                          label="NIT/CI"
                        />
                      </MDBCol>
                    </MDBRow>

                    <MDBRow className="xext-invoice-row mt-3">
                      <MDBCol md="9">
                        <XSelect
                          
                          key="tipo_documento"
                          id="tipo_documento"
                          color="primary"
                          getValue={this.selectHandler4}
                          options={this.state.tipos_documento}
                          label={"Tipo de Documento"}
                        />
                      </MDBCol>
                      <MDBCol md="3">
                        <XBtn
                          className="xext-invoice-generate-btn"
                          color="success"
                          onClick={() => {
                            //this.generateInvoice();
                            this.setState({
                              modal7: true,
                              optionMessage:
                                "¿Desea generar la factura de este pedido? Esta acción no se puede deshacer.",
                              opcion: "FACTURAR",
                            });
                          }}
                          className="w-100"
                          size="sm"
                        >
                          Generar Factura
                        </XBtn>

                        <XBtn
                          color="primary"
                          onClick={() => {
                            //this.generateInvoice(true);
                            this.setState({
                              modal7: true,
                              optionMessage:
                                "¿Está seguro de que desea realizar el bypass en este pedido? Debe completar el número de Factura",
                              opcion: "BYPASS",
                              numero_factura: "",
                            });
                          }}
                          className="w-100"
                          size="sm"
                        >
                          Bypass
                        </XBtn>

                        <XBtn
                          size="sm"
                          color="danger"
                          className="w-100"
                          onClick={() => {
                            this.setState({
                              modal33: false,
                            });
                          }}
                        >
                          Cancelar
                        </XBtn>
                      </MDBCol>
                    </MDBRow>
                  </>
                </MDBModalBody>
              </MDBModal>

              <MDBModal
                cascading
                centered
                isOpen={this.state.modal34}
                toggle={this.toggleModal(34)}
                size="lg"
              >
                <MDBModalBody>
                  <span className="h2-responsive mb-4">
                    {" "}
                    <MDBIcon icon="cart-arrow-down" className="mr-1" />{" "}
                    {"Anulación de Factura"}
                  </span>

                  <>
                    <MDBRow className="xext-invoice-row mt-3">
                      <MDBCol md="9">
                        <XSelect
                          key="store"
                          style={{ margin: 0 }}
                          id="motivo"
                          color="primary"
                          getValue={this.selectHandler34}
                          options={this.state.motivos}
                          label="Motivo de la anulación"
                        />
                      </MDBCol>
                    <MDBCol md="3">
                      <XBtn
                        color="success"
                          onClick={() => {
                            this.anulateInvoice();
                          }}
                        className="w-100 xext-invoice-generate-btn"
                        size="sm"
                      >
                          Anular
                        </XBtn>

                        <XBtn
                          size="sm"
                          color="danger"
                          className="w-100"
                          onClick={() => {
                            this.setState({
                              modal34: false,
                            });
                          }}
                        >
                          Cancelar
                        </XBtn>
                      </MDBCol>
                    </MDBRow>
                  </>
                </MDBModalBody>
              </MDBModal>

              <MDBModal
                cascading
                centered
                isOpen={this.state.modal4}
                toggle={this.toggleModal(4)}
                size="lg"
              >
                <MDBModalBody>
                  <span className="h2-responsive mb-2">
                    {" "}
                    <MDBIcon icon="cart-arrow-down" className="mr-1" /> Detalle
                    del pedido Previo{" "}
                  </span>

                  <p>Nombre: {this.state.customerName}</p>
                  <p>Direccion: {this.state.customerAdd}</p>
                  <p>Zona: {this.state.customerZone}</p>
                  {this.state.ordersPre.map((event) => (
                    <p key={"event2" + event.id} style={{ width: "98%" }}>
                      <Event
                        id={event.id}
                        product_id={event.product_id}
                        productName={event.productName}
                        productQty={event.productQty}
                        productPrice={event.productPrice}
                        productModel={event.productModel}
                        productImage={event.productImage}
                        productSKU={event.productSKU}
                        state={event.state}
                        onDelete={null}
                        onEdit={null}
                        onPick={null}
                      />
                    </p>
                  ))}
                </MDBModalBody>
              </MDBModal>

              <MDBModal
                cascading
                centered
                isOpen={this.state.modal3}
                toggle={this.toggleModal(3)}
                size="md"
              >
                <MDBModalBody>
                  <span className="h2-responsive mb-4">
                    {" "}
                    <MDBIcon icon="cart-arrow-down" className="mr-1" /> Agregar
                    Producto
                  </span>

                  <MDBRow className="xext-admin-row">
                    <MDBCol md="9">
                      <XInput
                        id="SKUcode"
                        key="SKUcode"
                        name="SKUcode"
                        value={this.state.SKUcode}
                        onChange={this.changeHandler}
                        size="sm"
                        label="SKU"
                      />
                    </MDBCol>
                    <MDBCol md="3" className="xext-admin-action">
                      <XBtn
                        color="secondary"
                        onClick={() => {
                          this.searchProduct();
                        }}
                        className="xext-admin-btn"
                        size="sm"
                      >
                        Buscar
                      </XBtn>
                    </MDBCol>
                  </MDBRow>

                  <MDBRow className="text-right">
                    <MDBCol md="12">
                      <XInput
                        id="productName"
                        label="Producto"
                        readOnly={true}
                        name="productName"
                        value={this.state.productName}
                        onChange={this.changeHandler}
                      />
                    </MDBCol>
                  </MDBRow>

                  <MDBRow className="text-right">
                    <MDBCol md="6">
                      <XInput
                        id="productPrice"
                        label="Precio"
                        readOnly={true}
                        name="productPrice"
                        value={this.state.productPrice}
                        onChange={this.changeHandler}
                      />
                    </MDBCol>

                    <MDBCol md="6">
                      <XInput
                        label="Cantidad"
                        id="productQty"
                        name="productQty"
                        readonly
                        type="number"
                        min="1"
                        max={this.state.productMaxQty}
                        value={this.state.productQty}
                        onChange={this.changeHandler}
                      />
                    </MDBCol>
                  </MDBRow>

                  <MDBRow className="text-right">
                    <MDBCol md="12">
                      <XBtn
                        size="sm"
                        color="success"
                        disabled={this.state.disabledAdd}
                        onClick={() => {
                          this.setState({
                            modal5: true,
                            mensaje: "Agregar este producto?",
                            accion: "agregar",
                          });
                        }}
                      >
                        {" "}
                        <MDBIcon icon="cart-plus" /> Agregar
                      </XBtn>
                    </MDBCol>
                  </MDBRow>
                </MDBModalBody>
              </MDBModal>

              <MDBModal
                cascading
                centered
                isOpen={this.state.modal5}
                toggle={this.toggleModal(5)}
                size="md"
              >
                <MDBModalBody className="text-center">
                  <span className="h4-responsive text-center">
                    Esta seguro de {this.state.mensaje}
                  </span>
                  <hr />

                  <MDBRow className="text-center">
                    <MDBCol md="12">
                      <MDBBtnGroup size="sm">
                        <XBtn
                          outline
                          onClick={() => {
                            this.setState({ modal5: false });
                          }}
                          color="danger"
                          className="text-capitalize"
                        >
                          {" "}
                          <span className="h4-responsive">Cancelar</span>
                        </XBtn>
                        <XBtn
                          onClick={() => {
                            this.setState({ modal5: false });
                            if (this.state.accion === "agregar") {
                              this.addOrder();
                            } else if (
                              this.state.accion === "eliminar tarifa"
                            ) {
                              this.deleteShipping(this.state.order_id);
                            } else if (this.state.accion === "aumentar") {
                              this.handleCommitEdit(
                                this.state.id_producto,
                                "Add"
                              );
                            } else if (this.state.accion === "disminuir") {
                              this.handleCommitEdit(
                                this.state.id_producto,
                                "Rem"
                              );
                            } else {
                              this.handleCommitDelete(this.state.id_producto);
                            }
                          }}
                          color="success"
                          className="text-capitalize"
                        >
                          {" "}
                          <span className="h4-responsive">
                            {this.state.accion}
                          </span>{" "}
                        </XBtn>
                      </MDBBtnGroup>
                    </MDBCol>
                  </MDBRow>
                </MDBModalBody>
              </MDBModal>
            </>
          )}

          <MDBModal
            cascading
            centered
            isOpen={this.state.modal7}
            toggle={this.toggleModal(7)}
            size="md"
          >
            <MDBModalBody className="text-center">
              <span className="h4-responsive text-center">
                {" "}
                {this.state.optionMessage}
              </span>
              <hr />
              {this.state.opcion === "BYPASS" && (
                <MDBRow className="text-center">
                  <MDBCol md="12">
                    <XInput
                      className="mt-3"
                      id={"numero_factura"}
                      key={"numero_factura"}
                      name={"numero_factura"}
                      value={this.state.numero_factura}
                      onChange={this.changeHandler}
                      size="sm"
                      label="Número Factura"
                    />
                  </MDBCol>
                </MDBRow>
              )}
              <MDBRow className="text-center">
                <MDBCol md="12">
                  <MDBBtnGroup size="sm">
                    <XBtn
                      outline
                      onClick={() => {
                        this.setState({ modal7: false });
                      }}
                      color="warning"
                    >
                      {" "}
                      <span className="h4-responsive">Cancelar</span>
                    </XBtn>
                    <XBtn
                      onClick={() => {
                        this.setState({ modal7: false });
                        console.log("ejecutar");
                        if (this.state.opcion === "BYPASS") {
                          console.log("aplicamos bypass");
                          this.generateInvoice(true);
                        } else {
                          console.log("facturamos");
                          this.generateInvoice();
                        }
                      }}
                      color="primary"
                    >
                      {" "}
                      <span className="h5-responsive">Confirmar</span>{" "}
                    </XBtn>
                  </MDBBtnGroup>
                </MDBCol>
              </MDBRow>
            </MDBModalBody>
          </MDBModal>

          <ToastContainer
            hideProgressBar={true}
            newestOnTop={false}
            position={"bottom-right"}
            autoClose={3000}
          />
        </MDBContainer>
      </>
    );
  }
}

class Event extends React.Component {
  render() {
    return this.props.state === "deleting" ? (
      <MDBCard
        style={{
          opacity: "0.4",
          backgroundColor: this.props.background
            ? this.props.background
            : "#999",
        }}
        className="align-items-center justify-content-center"
      >
        <p></p>
        <div className="media mt-4 align-middle">
          <div className="media-body mb-3 mb-lg-3">
            <MDBAnimation type="rotateOut" infinite>
              <MDBIcon
                style={{
                  zIndex: "1050",
                }}
                size="2x"
                far
                icon="trash-alt"
              />
            </MDBAnimation>
          </div>
        </div>
        <p></p>
      </MDBCard>
    ) : (
      <MDBCard
        className="xext-product-card"
        style={{
          backgroundColor: this.props.background
            ? this.props.background
            : "#fff",
        }}
      >
        <div className="media mt-1 xext-product-head">
          <span className="xext-product-side">
            {this.props.productQty}
            <br />

            <img
              src={this.props.productImage}
              height="60px"
              width="60px"
              alt="thumbnail"
              className="img-thumbnail xext-product-image"
            />
          </span>
          <div className="media-body mb-3 mb-lg-3">
            <span className="h6 mt-0 font-weight-bold xext-product-title">
              {this.props.productName}{" "}
            </span>{" "}
            <hr className="hr-bold my-2" />
            {this.props.product_id && (
              <React.Fragment>
                <p className="font-smaller mb-0 xext-product-meta">
                  <MDBRow className="align-items-left justify-content-left">
                    <MDBCol md="12">
                      <MDBIcon icon="shopping-basket" /> Codigo:{" "}
                      {this.props.productModel}
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className="align-items-left justify-content-left">
                    <MDBCol md="12">
                      <MDBIcon icon="barcode" /> SKU: {this.props.productSKU}
                      {this.props.preventaStatus === false && (
                        <span className="xext-preventa-pill xext-preventa-pill--pendiente">
                          Preventa: aun no llega
                        </span>
                      )}
                      {this.props.preventaStatus === true && (
                        <span className="xext-preventa-pill xext-preventa-pill--confirmada">
                          Preventa: lista
                        </span>
                      )}
                    </MDBCol>
                  </MDBRow>
                </p>
              </React.Fragment>
            )}
          </div>
        </div>
        {this.props.productQty && (
          <p className="p-2 mb-4  blue-grey lighten-5 xext-product-summary">
            {"Cantidad: " +
              this.props.productQty +
              ", Precio unitario: " +
              this.props.productPrice +
              ", Total " +
              parseInt(this.props.productPrice.replace("Bs.", "")) *
                parseInt(this.props.productQty) +
              "Bs."}
          </p>
        )}
      </MDBCard>
    );
  }
}

export default externalForm01;

